
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl=null) {
        const url = pageUrl ? pageUrl : `${API_URL}/evidence`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/evidence/${id}`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.assigned_id = userId.id;
        
        return axios.post(`${API_URL}/evidence`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/evidence/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/evidence/${id}`, { headers: authHeader() });
    },
    checkData(id, data){
         // Obtener el user_id desde el localStorage
         let userId = JSON.parse(localStorage.getItem('user'));

         // Validar el user_id
         if (!userId || !userId.id) {
             throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
         }
 
         data.user_id = userId.id;
        return axios.patch(`${API_URL}/evidences/${id}/verify`, data, { headers: authHeader() });
    }
};